import type { CreateFaqPayload, Faq } from '../entities/faq.entity'
import type { FaqRepository } from '../repositories/faq_repository'

export class CreateFaqUseCase {
  constructor(private readonly repository: FaqRepository) {}

  execute(payload: CreateFaqPayload): Promise<Faq> {
    return this.repository.create(payload)
  }
}
